import React, {Fragment, useState, useEffect} from "react";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import utentiUtils from "./utentiutils";
import {gruppi} from '../../../api/groups'
import {utenti} from '../../../api/users'
import {ruoli} from '../../../api/roles'
import {ToastContainer, toast} from "react-toastify";


import DataTable from "react-data-table-component";
import {useQuery} from '../../../hook/useQuery'
import { HasRole } from 'react-role-permission'

const Utenti = (props) => {
    const columns = [
      {
        name: "Username",
        selector: "username",
        sortable: true,
        center: true,
        className: "default-text mb-0 f-w-700 f-18",
        style: 'color: var(--primary-color);font-weight: 700;font-size: 14px;',
        width: '15%'

      },
      {
        name: "Gruppo",
        selector: "groups",
        sortable: true,
        center: true,
        className: "default-text mb-0 f-w-700 f-18",
        width: '15%',
        format: (row) => {
          return (<span className={"badge badge-pill recent-badge f-12"}>{row.groups ? row.groups[0].name : '-'}</span>)
        },

      },
      {
        name: "Ruolo",
        selector: "role",
        sortable: true,
        center: true,
        className: "default-text mb-0 f-w-700 f-18",
        width: '15%',
        format: (row) => {
          return (<span className="badge badge-pill recent-badge f-12">{row.role ? row.role.role : '-'}</span>)
        },

      },
      {
        name: "Abilitato",
        selector: "enabled",
        sortable: true,
        center: true,
        format: (row) => {
          return (

            row.enabled ? (<span className="badge badge-pill badge-success">{" "}</span>) : (
              <span className="badge badge-pill badge-danger">{" "}</span>))
        },
        width: '15%'
      },

      // {
      //   name: "Data evento",
      //   selector: "timestamp",
      //   sortable: true,
      //   center: true,
      //   width: '20%',
      //   format: (row) => {
      //     return moment(new Date(row.timestamp)).format('DD/MM/YYYY h:mm:ss')

      //   }
      // },


      {
        name: "Azioni",
        selector: "id",
        sortable: true,
        center: true,
        format: (row) => {
          // console.log(localStorage.getItem('grp'));
          if((row.role.id!=1 || row.role.role!=localStorage.getItem('rl'))
            &&
            (HasRole('admin')
              || (HasRole('group_admin') && row.groups[0].id==localStorage.getItem('grp'))
            )
            ){
            return (
              <>
                  <Button color="warning"
                          className="btn btn-pill btn-sm btn-air-warning btn-warning"
                          onClick={loadFormEdit.bind(this, row)}>Gestisci</Button>
                &nbsp;
                <Button color="primary"
                        className="btn btn-pill btn-sm btn-air-danger  btn-danger"
                        onClick={deleteuser.bind(this, row.id, row.username)}>Elimina</Button>

              </>
            )

          }else
            return('');
        },
      },
    ];
    const query = useQuery();

    const userId = query.get('id');
    const [listaUtenti, setListaUtenti] = useState([]);
    const [enabled, setEnabled] = useState(true);
    const [groupid, setGroupId] = useState('');

    const [id, setId] = useState();
    const [name, setName] = useState('');
    const [roleid, setRoleId] = useState('');
    const [rolename, setRoleName] = useState('');
    const [surname, setSurname] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [listaruoli, setListaRuoli] = useState([]);
    const [listagruppi, setListaGruppi] = useState([]);
    const [isloading, setIsLoading] = useState(false);

    useEffect(() => {
      load();
    }, []);

    useEffect(() => {

    }, [userId, listaUtenti]);

    const load = async () => {
      try {
        const list = await gruppi.methods.loadGruppi();
        setListaGruppi(list);
      } catch (e) {

      }
      try {
        const list = await ruoli.methods.loadRuoli();
        setListaRuoli(list);
      } catch (e) {

      }

      try {
        const listautentiraw = await utenti.methods.loadUtenti();
        if (listautentiraw) {
          let listautenti = listautentiraw.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.timestamp) - new Date(a.timestamp);
          })

          setListaUtenti(listautenti);
        }
      } catch (e) {

      }

    }



    const loadutenteEdit = (inputobject) => {

      setName(inputobject.name)
      setRoleId(inputobject.role.id)
      setRoleName(inputobject.role.role)
      setSurname(inputobject.surname)
      setUsername(inputobject.username)
    }

    const clearForm = () => {
      setId(null);
      setName('')
      setRoleId('')
      setGroupId('')
      setRoleName('')
      setSurname('')
      setUsername('')
      setPassword('')
      document.getElementById('roleselect').value='';
      document.getElementById('groupselect').value='';
    }

    const loadFormEdit = (row) => {
      setId(row.id);
      setName(row.name)
      setRoleId(row.role.id)
      setGroupId(row.groups[0].id)
      setSurname(row.surname)
      setUsername(row.username)
      setPassword(row.password)
      setEnabled(row.enabled)
      document.getElementById('roleselect').value=row.role.id;
      document.getElementById('groupselect').value=row.groups[0].id;
    }

    const deleteuser = async (id,name) => {
        if(window.confirm('Eliminare utente ' + name)){
          await utentiUtils.methods.deleteUtente(id);
        setTimeout(() => {
          toast.success(
            'Utente cancellato'
          );
        }, 300);
        load();
      }

    }

    const submit = async () => {
      setIsLoading(true)
      setId(query.get('id'));
      console.log(enabled)
      const inputobject =
        {
          "enabled": enabled,
          "groups": [
            {
              "id": groupid,
              "name": 'admin'//groupname
            }
          ],
          "name": name,
          "role": {
            "id": roleid,
            "role": 'admin'//rolename
          },
          "surname": surname,
          "username": username,
          "password":password
        }
      if(id) inputobject.id=(id);
      console.log(inputobject)
      const validateresult = utentiUtils.methods.validateUtente(inputobject,id ? true : false);
      if (validateresult.length > 0) {
        console.log(2);
        //TODO gestire validate field su campo input
        validateresult.forEach((e) => {
            console.log(e);
            setTimeout(() => {
              toast.error(
                e.field + ':' + e.error
              );
            }, 300);


          }
        );

        setIsLoading(false)

        return;
      }

      const result = await utentiUtils.methods.saveUtente(inputobject, id);

      if (result) {
        setTimeout(() => {
          toast.success(
            "Utente salvata..."
          );

        }, 300);
      } else {
        setTimeout(() => {
          toast.error(
            "Qualcosa è andato storto..."
          );
        }, 300);

      }
      clearForm();
      load(true);
      setIsLoading(false)
    }


    return (
      <Fragment>
        <Breadcrumb parent="Utenti" title="Gestione" subtitle="Utenti"/>
        <Container fluid={true}>
          <Row>
            <Col xs="12">
              <Card className="card-absolute">
                <CardHeader className="bg-primary">
                  <h5>Dati Utente {username}</h5>
                </CardHeader>
                <CardBody className="add-post">
                  <Form id="savesession" className="row needs-validation">
                    <Col sm="12">
                      <Row>
                        <Col xs="12" sm="6" md="6" xl="6" lg="6">
                          <FormGroup>
                            <Label for="validationCustom01">Nome:</Label>
                            <Input
                              className="form-control"
                              id="input_nome_utente"
                              type="text"
                              placeholder=""
                              required={true}
                              value={name}
                              onChange={(e) => {
                                setName(e.target.value)
                              }}
                            />
                            <div className="valid-feedback">Ok!</div>
                          </FormGroup>

                        </Col>
                        <Col xs="12" sm="6" md="6">

                          <FormGroup>
                            <Label for="validationCustom01">Cognome:</Label>
                            <Input
                              className="form-control"
                              id="input_cognome_utente"
                              type="text"
                              placeholder=""
                              required={true}
                              value={surname}
                              onChange={(e) => {
                                setSurname(e.target.value)
                              }}
                            />
                            <div className="valid-feedback">Ok!</div>
                          </FormGroup>

                        </Col>


                      </Row>
                      <Row>
                        <Col xs="12" sm="6" md="6" xl="6" lg="6">
                          <FormGroup>
                            <Label for="validationCustom01">Username:</Label>
                            <Input
                              className="form-control"
                              id="input_nome_utente"
                              type="text"
                              placeholder=""
                              required={true}
                              value={username}
                              onChange={(e) => {
                                setUsername(e.target.value)
                              }}
                            />
                            <div className="valid-feedback">Ok!</div>
                          </FormGroup>

                        </Col>
                        <Col xs="12" sm="6" md="6">

                          <FormGroup>
                            <Label for="validationCustom01">Password:</Label>
                            <Input
                              className="form-control"
                              id="input_cognome_utente"
                              type="password"
                              placeholder=""
                              required={true}
                              value={password}
                              onChange={(e) => {
                                setPassword(e.target.value)
                              }}
                            />
                            <div className="valid-feedback">Ok!</div>
                          </FormGroup>

                        </Col>


                      </Row>
                      <Row>
                        <Col xs="12" sm="6" md="6" xl="6" lg="6">
                          <FormGroup>
                            <Label for="validationCustom01">Gruppo:</Label>
                            <select id="groupselect" className="form-control btn-pill" onChange={(e) => {
                              setGroupId(e.target.value)
                            }} size="1">
                              <option value=''>Seleziona</option>
                              {
                                Array.isArray(listagruppi) ? listagruppi.map((data, i) => {
                                  return (
                                    <option value={data.id}>{data.name}</option>
                                  );
                                }) : <option value={1}>{'admin'}</option>
                              }


                            </select>


                          </FormGroup>

                        </Col>
                        <Col xs="12" sm="6" md="6" xl="6" lg="6">
                          <FormGroup>
                            <Label for="validationCustom01">Ruolo:</Label>
                            <select id="roleselect" className="form-control btn-pill" onChange={(e) => {
                              setRoleId(e.target.value)
                            }} size="1">
                              <option value=''>Seleziona</option>
                              {
                                listaruoli.map((data, i) => {
                                  if(data.role.toUpperCase()!='ANONYMOUS'){
                                    return (
                                      <option value={data.id}>{data.role.toUpperCase()}</option>
                                    );
                                  }else
                                    return '';

                                })
                              }


                            </select>

                          </FormGroup>

                        </Col>

                      </Row>
                      <Row>
                        <Col xs="12" sm="9">

                        </Col>
                        <Col xs="12" sm="3">
                          <FormGroup>
                            <div className="checkbox checkbox-success">
                              <Input
                                id="checkbox-primary"
                                type="checkbox"
                                defaultChecked
                                onChange={(e) => {
                                  console.log(e.target.checked)
                                  setEnabled(e.target.checked)
                                }}
                              />
                              <Label for="checkbox-primary">Abilitato</Label>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Form>
                  <Row>
                    &nbsp;
                  </Row>
                  <div className="btn-showcase" style={{textAlign: 'right'}}>
                    <Button disabled={isloading} id="buttonsubmit" color="primary btn-pill" type="button"
                            onClick={submit}>
                      {id? 'Modifica' : 'Aggiungi'}
                    </Button>
                    <Button color="danger btn-pill" type="reset" onClick={clearForm}>
                      Annulla
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>

          </Row>
          <Row>
            <Col xs="12" sm="12">
              <Card className="card-absolute">
                <CardHeader className="bg-secondary">
                  <h5>Lista Utenti</h5>
                </CardHeader>
                <CardBody className="add-post">
                  <DataTable
                    columns={columns}
                    data={listaUtenti.filter((user, ix) => ix < 10)}
                    striped={true}
                    center={true}
                    className="table-xs table table-styling"
                    style={{
                      marginTop: "0px",
                      maxWidth: "100%",
                      overflow: 'auto',
                      width: '100%',
                      position: 'relative',
                      top: '-55px'
                    }}
                    pagination={true}
                    paginationPerPage={5}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer/>
        </Container>
      </Fragment>
    );
  }
;

export default Utenti;
